/**
 * Pure display-only calculation helpers.
 * Mirrors backend formulas for frontend what-if simulations.
 * Does NOT change any backend scoring or persist any data.
 */

export function monthlyMortgage(principal, annualRate, years) {
  const r = annualRate / 100 / 12;
  const n = years * 12;
  if (r === 0) return n > 0 ? principal / n : 0;
  return principal * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
}

export function simulateCashFlow(deal, overrides = {}) {
  const d = { ...deal, ...overrides };
  const pp = d.purchase_price || 0;
  const dpPct = d.down_payment_percent || 20;
  const rate = d.interest_rate || 5;
  const term = d.loan_term_years || 25;
  const income = d.annual_income || 0;
  const vac = d.vacancy_rate || 5;
  const mgmt = d.property_management_percent || 10;
  const tax = (d.annual_property_tax || 0) / 12;
  const ins = (d.annual_insurance || 0) / 12;
  const maint = d.monthly_maintenance || 0;

  const dp = pp * (dpPct / 100);
  const loan = pp - dp;
  const mtg = monthlyMortgage(loan, rate, term);
  const mi = income / 12;
  const exp = tax + ins + maint + mi * (vac / 100) + mi * (mgmt / 100);
  return Math.round(mi - mtg - exp);
}

export function getDecision(recommendation) {
  if (['strong_buy', 'buy'].includes(recommendation)) return 'pass';
  if (['consider', 'review_carefully'].includes(recommendation)) return 'hold';
  return 'fail';
}

export function getRiskLevel(score) {
  if (score >= 70) return 'low';
  if (score >= 40) return 'moderate';
  return 'high';
}
